import React from "react";
import { Menu, Card } from "antd";
import { BiMessageDots } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { MdHelpOutline } from "react-icons/md";
// import { GrNotes } from "react-icons/gr";
import { DarkModeToggle } from "../components";

import Profile from "../assets/profile-image.png";

const ProfileMenu = () => {
  return (
    <Card style={{ borderRadius: 20, padding: 30 }} className="profileMenu">
      <Menu style={{ width: "450px"}}>
        <Menu.Item style={{ height: 70 }}>
          <div className="flex items-center">
            <div className="mr-5">
              <img src={Profile} width={40} />
            </div>
            <div>
              <h6 className="text-sm font-bold">Virtue Osakwe</h6>
              <small>View my Profile</small>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item
          style={{
            height: 70,
            borderTop: "1px solid #c7c1c1",
            borderBottom: "1px solid #c7c1c1",
          }}
        >
          <div className="flex items-center">
            <div className="mr-5">
              <BiMessageDots />
            </div>
            <div style={{ padding: "7px 0" }}>
              <h6 className="text-sm font-bold">Feedback</h6>
              <small>View my Profile</small>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item>
          <div className="flex items-center">
            <div className="mr-5">
              <IoSettingsOutline />
            </div>
            <div>
              <h6 className="text-sm font-bold">Settings & Privacy</h6>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item>
          <div className="flex items-center">
            <div className="mr-5">
              <MdHelpOutline />
            </div>
            <div>
              <h6 className="text-sm font-bold">Help</h6>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item>
          <div className="flex items-center">
            <div className="mr-5">
              <DarkModeToggle />
            </div>
            <div>
              <h6 className="text-sm font-bold">Display Mode</h6>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item>
          <div className="flex items-center">
            <div className="mr-5">
              <MdHelpOutline />
            </div>
            <div>
              <h6 className="text-sm font-bold">Activity</h6>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item style={{ height: 50, borderTop: "1px solid #c7c1c1" }}>
          <div className="flex items-center">
            <div className="mr-5">
              <IoIosLogOut />
            </div>
            <div>
              <h6 className="text-sm font-bold">Sign Out</h6>
            </div>
          </div>
        </Menu.Item>
      </Menu>
    </Card>
  );
};

export default ProfileMenu;
